import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-horario-actividades-importar',
  standalone: false,
  templateUrl: './horario-actividades-importar.component.html',
  styleUrls: ['./horario-actividades-importar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HorarioActividadesImportarComponent implements OnInit {

  actividades: any[];
  horario: any;

  constructor(public dialogRef: MatDialogRef<HorarioActividadesImportarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.actividades = this.data.actividades;
      this.horario = this.data.data;
    }

  ngOnInit(): void {
    this.actividades.forEach(item => {
      item.nombre = this.horario.subjects.find(subject => subject.id === item.subjectId).name;
    });
  }

}
